<script setup lang="ts">
import type { IBenefitProps } from '@/domains/career/main/components/career-main-benefits/CareerMainBenefit/career-main-benefit.types'
  
defineProps<IBenefitProps>()
</script>
  
<template>
  <div
    class="career-main-benefit"
  >
    <div class="career-main-benefit__image">
      <img
        :src="benefit.image[0].url"
        :alt="benefit.title"
      >
    </div>
      
    <div class="career-main-benefit__title">
      {{ benefit.title }}
    </div>
  
    <div class="career-main-benefit__description">
      {{ benefit.description }}
    </div>
  
    <div class="career-main-benefit__category">
      {{ category }}
    </div>
  </div>
</template>
  
  <style lang="scss" scoped>
  .career-main-benefit {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1.6rem;
    width: 30rem;
    padding: 3.2rem;
    background-color: $white;
    border-radius: 0.8rem;
    transition: all 300ms ease;
  
    &:hover {
      box-shadow: 0 1rem 3rem rgba(124, 73, 190, 0.1);
      transform: translateY(-0.5rem);
    }
  
    &__image {
      width: 6rem;
      height: 6rem;
    }
  
    &__title {
      @include body-3-medium;
      color: $text-500;
    }
  
    &__description {
      @include body-4;
      color: $text-500;
    }
  
    &__category {
      width: fit-content;
      padding: 0.8rem 1.6rem;
      color: $text-500;
      font-weight: 500;
      background-color: $white;
      border: 1px solid $gray-300;
      border-radius: 0.8rem;
    }
  }
</style>
